module.exports = __webpack_public_path__ + "static/media/02.Akad.Prog.Photo.e1b55366.jpg";